import React, {ComponentType} from 'react';
import {getDisplayName} from 'recompose';
import hoistStatics from 'hoist-non-react-statics';

export const forwardRefs = (Component: ComponentType): ComponentType => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const forwarder = (props: any, ref: any) => <Component {...{forwardedRef: ref, ...props}} />;

    const Container = React.forwardRef(forwarder);
    const displayName = getDisplayName(Component);

    forwarder.displayName = displayName;
    Container.displayName = displayName;

    hoistStatics(Container, Component);

    return Container;
};

export const restoreRefs = (Component: ComponentType): ComponentType => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const Container = ({forwardedRef: ref, ...props}: any) => <Component ref={ref} {...props} />;

    Container.displayName = getDisplayName(Component);

    return Container;
};
